// components
import { Typography } from '@mui/material';
import { Icon } from '@sdb/planning-ui';

// hooks
import { useTranslation } from 'react-i18next';

// styles
import { IconContainer } from 'components/shared/Header/Header.styles';
import {
  StyledSignalsFlexBox,
  StyledSignalsInnerBox
} from './SignalsTooltipLegend.styles';
import { StyledSignalsTooltipBox } from './DutyCell.styles';

// types
import type {
  DutySignalKeys,
  DutySignals
} from 'components/shared/ToolbarSet/components/DutyChip.types';
import type { IconType } from '@sdb/planning-ui/ui-3/packages/icons/__generated__';

const SignalsTooltipLegend = ({ signals }: { signals: DutySignals[] }) => {
  const { t } = useTranslation('common', {
    keyPrefix: 'rosterPlan.dataGrid.tooltip'
  });

  const getSignalDescription = (signal: DutySignalKeys) => {
    switch (signal) {
      case 'hasNotes':
        return 'hasNotes';
      case 'hasQualifications':
        return 'hasQualifications';
      case 'hasUpdatedDutyHourType':
        return 'hasUpdatedDutyHourType';
      case 'hasPreferredEmployees':
        return 'hasPreferredEmployees';
      case 'isAiMatch':
        return 'isAiMatch';
      default:
        return '';
    }
  };

  const getSignalIcon = (signal: DutySignalKeys): IconType => {
    switch (signal) {
      case 'hasNotes':
        return 'note';
      case 'hasQualifications':
        return 'medal';
      case 'hasUpdatedDutyHourType':
        return 'asterisk';
      case 'hasPreferredEmployees':
        return 'users';
      case 'isAiMatch':
        return 'double-sparkle';
    }
  };

  return (
    <StyledSignalsTooltipBox>
      <StyledSignalsFlexBox>
        {signals.map((signal) =>
          signal.active ? (
            <StyledSignalsInnerBox key={signal.key}>
              <IconContainer iconSize="SMALL">
                <Icon type={getSignalIcon(signal.key)} />
              </IconContainer>
              <Typography variant="body2">
                {t(getSignalDescription(signal.key))}
              </Typography>
            </StyledSignalsInnerBox>
          ) : null
        )}
      </StyledSignalsFlexBox>
    </StyledSignalsTooltipBox>
  );
};

export default SignalsTooltipLegend;
